var map = {
	"./arrow-back": 522,
	"./arrow-back.js": 522,
	"./arrow-back2": 523,
	"./arrow-back2.js": 523,
	"./arrow-down-3": 524,
	"./arrow-down-3.js": 524,
	"./arrow-forward": 525,
	"./arrow-forward.js": 525,
	"./ban": 526,
	"./ban.js": 526,
	"./bar-code": 527,
	"./bar-code.js": 527,
	"./bar-code2": 528,
	"./bar-code2.js": 528,
	"./bonus": 529,
	"./bonus.js": 529,
	"./calendar": 530,
	"./calendar.js": 530,
	"./card": 531,
	"./card.js": 531,
	"./card2": 532,
	"./card2.js": 532,
	"./check": 533,
	"./check.js": 533,
	"./checkbox": 534,
	"./checkbox.js": 534,
	"./cog": 535,
	"./cog.js": 535,
	"./credit": 536,
	"./credit.js": 536,
	"./discard": 537,
	"./discard.js": 537,
	"./euro": 538,
	"./euro.js": 538,
	"./fast-backward": 539,
	"./fast-backward.js": 539,
	"./fast-forward": 540,
	"./fast-forward.js": 540,
	"./file": 541,
	"./file.js": 541,
	"./img": 542,
	"./img.js": 542,
	"./info": 543,
	"./info.js": 543,
	"./kebab-menu": 544,
	"./kebab-menu.js": 544,
	"./list": 545,
	"./list.js": 545,
	"./minus": 546,
	"./minus.js": 546,
	"./open-popup": 547,
	"./open-popup.js": 547,
	"./package": 548,
	"./package.js": 548,
	"./pdf": 549,
	"./pdf.js": 549,
	"./pdfWhite": 550,
	"./pdfWhite.js": 550,
	"./pencil": 551,
	"./pencil.js": 551,
	"./percent": 552,
	"./percent.js": 552,
	"./plus": 553,
	"./plus.js": 553,
	"./sale": 554,
	"./sale.js": 554,
	"./search": 555,
	"./search.js": 555,
	"./sheet": 556,
	"./sheet.js": 556,
	"./spinner": 557,
	"./spinner.css": 558,
	"./spinner.js": 557,
	"./tableware": 559,
	"./tableware.js": 559,
	"./transactions": 560,
	"./transactions.js": 560,
	"./trash": 561,
	"./trash.js": 561,
	"./users": 562,
	"./users.js": 562,
	"./voucher": 563,
	"./voucher.js": 563,
	"./wallet": 564,
	"./wallet.js": 564,
	"./xls": 565,
	"./xls.js": 565,
	"./xlsWhite": 566,
	"./xlsWhite.js": 566
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 899;